import { useRecordTypes } from '../../../../hooks';
export var useFilterConfig = function () {
    var _a = useRecordTypes(), _b = _a.recordTypes, recordTypes = _b === void 0 ? [] : _b, isLoading = _a.isLoading;
    var filterConfig = [
        {
            label: 'Status',
            name: 'status',
            cql: 'status',
            values: ['Active', 'Inactive']
        }, {
            label: 'Visibility',
            name: 'visibility',
            cql: 'visibility',
            values: ['Shared', 'Private']
        }, {
            label: 'Record types',
            name: 'record_types',
            cql: 'record.types',
            values: recordTypes === null || recordTypes === void 0 ? void 0 : recordTypes.map(function (item) {
                var _a;
                return ({ name: (_a = item.id) !== null && _a !== void 0 ? _a : item.label, displayName: item.label, cql: item.id });
            })
        }
    ];
    return {
        filterConfig: filterConfig,
        isLoadingConfigData: isLoading
    };
};
